import React from 'react';

import Logo from '../../../components/global/Logo';
import PasswordResetContainer from '../../../containers/auth/PasswordResetContainer';
import SplitLayout from '../../../components/global/SplitLayout';

const PasswordResetView = () => (
  <div className="auth-password-reset">
    <SplitLayout.Wrapper>
      <div className="branding-space">
        <Logo />
      </div>

      <h2 className="password-reset-header mb-1">Reset your password</h2>

      <PasswordResetContainer />
    </SplitLayout.Wrapper>
  </div>
);

export default PasswordResetView;
